export class GoalCategory {
    public static readonly ALL:GoalCategory = new GoalCategory("", "All", "All Goal Categories");

    constructor(goalCategoryId:string = "", name:string = "", description:string = "",startdate:string = "",enddate:string = "") {
        this.GoalCategoryId = goalCategoryId;
        this.Name = name;
        this.Description = description;
        //MCM-2320: Addded for new start date and end date logic for goal category
        this.StartDate = startdate;
        this.EndDate = enddate;
    }
    
    public GoalCategoryId: string;
    public Name: string;
    public Description: string;
    public SortOrder:number;
    public IsDeleted:boolean;

    // MCM-2320 : Added for categories start and end date.
    public StartDate:string;
    public EndDate:string;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/goal-category.ts